import {useLocation} from 'react-router-dom';

export const useQueryParam = (): URLSearchParams => {
  const location = useLocation();

  return new URLSearchParams(location.search);
};
